import {useSelector} from 'react-redux'
import {whereNot} from '../../../../index'

export const useWhereNot = (kind, query, opts) => {
	const items = useSelector(state => whereNot(state, kind, query, opts))
	return items
}

export default useWhereNot
